module.exports = __webpack_public_path__ + "static/media/ship_red.6a087cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_red.png
// module id = 201
// module chunks = 0